import { render, staticRenderFns } from "./sale-order-form.vue?vue&type=template&id=6b03bbdc&scoped=true&"
import script from "./sale-order-form.vue?vue&type=script&lang=js&"
export * from "./sale-order-form.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-form.vue?vue&type=style&index=0&id=6b03bbdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03bbdc",
  null
  
)

export default component.exports